import { render, staticRenderFns } from "./r-info-panel.vue?vue&type=template&id=608ab774"
import script from "./r-info-panel.vue?vue&type=script&lang=js"
export * from "./r-info-panel.vue?vue&type=script&lang=js"
import style0 from "./r-info-panel.vue?vue&type=style&index=0&id=608ab774&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports